/**
 * Lightweight ES contact page (Phase 1 placeholder).
 * Phase 2 will expand with map, hours, full address, etc.
 */
import React from 'react';
import EsSEO from '@/components/seo/EsSEO';
import BilingualForm from '@/components/BilingualForm';
import useSpanishTrackingNumber from '@/hooks/useSpanishTrackingNumber';

const SITE = 'https://fortworthdental.com';

const SpanishContactPage = () => {
  const { displayNumber, telLink } = useSpanishTrackingNumber();
  return (
  <>
    <EsSEO
      title="Contacto – Fort Worth Dental"
      description="Llámanos o reserva tu cita en línea. Atendemos sin cita previa para emergencias dentales en Fort Worth, TX."
      canonical="/es/contacto"
      hreflangEn="/contact-us"
      schema={{
        '@context': 'https://schema.org',
        '@type': 'ContactPage',
        url: `${SITE}/es/contacto`,
        inLanguage: 'es-US',
        about: { '@type': 'Dentist', name: 'Fort Worth Dental' },
      }}
    />

    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 max-w-5xl">
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">Contáctanos</h1>
        <p className="text-lg text-gray-700 mb-8">
          Llámanos al <a href={telLink} className="text-teal-600 font-semibold hover:underline">{displayNumber}</a> o
          completa el formulario y te contactaremos dentro de 1 día hábil. Hablamos español.
        </p>

        <div className="grid lg:grid-cols-2 gap-10">
          <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 lg:p-8">
            <h2 className="text-xl font-bold text-gray-900 mb-4">Solicita tu cita</h2>
            <BilingualForm lang="es" source="es_contact_page" />
          </div>

          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="font-semibold text-gray-900">Dirección</h3>
              <p>4620 Citylake Blvd W<br />Fort Worth, TX 76132</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">Teléfono</h3>
              <p><a href={telLink} className="text-teal-600 hover:underline">{displayNumber}</a></p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">Horario de Atención</h3>
              <table className="w-full max-w-sm text-sm mt-2">
                <tbody>
                  <tr><td className="py-1 pr-4">Lunes</td><td>9:00 am – 5:00 pm</td></tr>
                  <tr><td className="py-1 pr-4">Martes</td><td>9:00 am – 6:00 pm</td></tr>
                  <tr><td className="py-1 pr-4">Miércoles</td><td>7:00 am – 5:00 pm</td></tr>
                  <tr><td className="py-1 pr-4">Jueves</td><td>9:00 am – 6:00 pm</td></tr>
                  <tr><td className="py-1 pr-4">Viernes</td><td>7:00 am – 2:00 pm</td></tr>
                </tbody>
              </table>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">Atención sin cita previa</h3>
              <p>Para emergencias dentales atendemos sin cita previa el mismo día.</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">¿Hablan español?</h3>
              <p>Sí — atendemos a familias hispanas en todo el condado de Tarrant.</p>
            </div>
          </div>
        </div>

        {/* Google Map */}
        <div className="mt-12" data-testid="es-contact-map">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Encuéntranos</h2>
          <div className="aspect-video rounded-lg overflow-hidden shadow-lg">
            <iframe
              title="Fort Worth Dental — Mapa de Google"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3354.8!2d-97.4383!3d32.7284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e6d61e2da5abf%3A0xbabb72c14307254a!2sFort%20Worth%20Dental!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  </>
  );
};

export default SpanishContactPage;
